// extracted by mini-css-extract-plugin
export default {"JobsTasks__Table":"styles_JobsTasks__Table__qHA6q"};